import { createRoot } from 'react-dom/client'
import WinnersTable from '../WinnersTable.jsx'


document.addEventListener("DOMContentLoaded", function() {
	const blocks = document.getElementsByClassName('bw-winner-winners-table-block')
	for (const domNode of blocks) {
		const attributes = window['bw_block_' + domNode.id]
		const root = createRoot(domNode)
		root.render(<WinnersTable attributes={attributes} />)
	}
})
